document.addEventListener("DOMContentLoaded", function() {
    const announcementBars = document.querySelectorAll('#shopify-section-announcement-bar .announcement-bar');
    const l = announcementBars.length;
    let i = 0;
    function changeBar() {
        announcementBars[i].classList.remove('active');
        if (i < l - 1) {
            i = i + 1;
        } else {
            i = 0;
        }
        announcementBars[i].classList.add('active');
        setTimeout(changeBar, 7000);
    }
    document.addEventListener('UserInteracted', changeBar, false);
});